import { render } from "./LeavesPage.vue?vue&type=template&id=3bba6297&scoped=true"
import script from "./LeavesPage.vue?vue&type=script&lang=js"
export * from "./LeavesPage.vue?vue&type=script&lang=js"

import "./LeavesPage.vue?vue&type=style&index=0&id=3bba6297&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bba6297"]])

export default __exports__